import React from "react";
import "../../SignIn/SignIn.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../../assets/communityXlogo.svg";
import Form from "react-bootstrap/Form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import forgot from "../../../assets/forgot.png";
import { MdArrowBack } from "react-icons/md";
import { useState } from "react";
import {
  ConfirmPasswordCheck,
  CreatePasswordCheck,
} from "../../../ConditionChecks/ConditionChecks";
import { CreatePswdApi } from "../../../Utils/Api/CreatePswdApi";
import ErrorLabel from "../../../Components/ErrorLabel/ErrorLabel";
import Loader from "../../../Components/Loader/Loader";
import {
  SignUpCreatePassword,
  SignUpCreatePasswordApi,
} from "../../../Utils/Api/SignUpCreatePasswordApi";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ServerError } from "../../../Utils/GlobalVariables/ToastifierVariables";
import moment from "moment-timezone";

const CreatePasswordPage = () => {
  const currentTimeZone = moment.tz.guess();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errDisplayNewPswd, setErrDisplayNewPswd] = useState("");
  const [errDisplayConfirmPswd, setErrorDisplayConfirmPswd] = useState("");
  const [apiErrDisplay, setApiErrDisplay] = useState("");
  const [loading, setLoading] = useState(false);
  const [visiblePassword, setVisiblePassword] = useState({
    NewPswd: false,
    ConfirmPswd: false,
  });

  const navigate = useNavigate();

  const BuId = localStorage.getItem("BuUserId");

  const VisibleHandler = (val) => {
    if (val === "NewPswd") {
      setVisiblePassword((ps) => {
        return { ...ps, NewPswd: true };
      });
    } else if (val === "ConfirmPswd") {
      setVisiblePassword((ps) => {
        return { ...ps, ConfirmPswd: true };
      });
    }
  };

  const NotVisibleHandler = (val) => {
    if (val === "NewPswd") {
      setVisiblePassword((ps) => {
        return { ...ps, NewPswd: false };
      });
    } else if (val === "ConfirmPswd") {
      setVisiblePassword((ps) => {
        return { ...ps, ConfirmPswd: false };
      });
    }
  };

  const onNewPswd = (e) => {
    let NewPswd = e.target.value;
    setNewPassword(NewPswd);
    setErrDisplayNewPswd("");
  };

  const onConfirmPswd = (e) => {
    let ConfirmPswd = e.target.value;
    setConfirmPassword(ConfirmPswd);
    setErrorDisplayConfirmPswd("");
  };

  const BackHandler = () => {
    navigate("/signup");
  };

  const SaveHandler = (e) => {
    e.preventDefault();
    const NewPasswordValidation = CreatePasswordCheck(newPassword);
    const ConfirmPasswordValidation = ConfirmPasswordCheck(
      newPassword,
      confirmPassword
    );

    if (NewPasswordValidation.input === "empty") {
      setErrDisplayNewPswd(NewPasswordValidation.err_display);
    } else if (NewPasswordValidation.input === "lesscharacters") {
      setErrDisplayNewPswd(NewPasswordValidation.err_display);
    } else if (NewPasswordValidation.input === "invalid") {
      setErrDisplayNewPswd(NewPasswordValidation.err_display);
    }

    if (ConfirmPasswordValidation.input === "empty") {
      setErrorDisplayConfirmPswd(ConfirmPasswordValidation.err_display);
    } else if (ConfirmPasswordValidation.input === "deosnotmatch") {
      setErrorDisplayConfirmPswd(ConfirmPasswordValidation.err_display);
    }

    if (
      NewPasswordValidation.validition &&
      ConfirmPasswordValidation.validition === true
    ) {
      let NewPswd = {
        user_id: parseInt(BuId),
        password: newPassword.trim(),
        confirm_password: confirmPassword.trim(),
        time_zone: currentTimeZone,
      };
      CreateNewPasswordHandler(NewPswd);
    }
  };

  const CreateNewPasswordHandler = async (data) => {
    setLoading(true);
    const NewPswdResponse = await SignUpCreatePasswordApi(data, () => {
      navigate("/");
    });
    if (NewPswdResponse === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (NewPswdResponse.success === true) {
        toast.success(NewPswdResponse.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        localStorage.removeItem("BuUserId");
        navigate("/SignedUpSuccesfully");
        setLoading(false);
      } else {
        toast.error(NewPswdResponse.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col md="6" className="page-content-left text-center hide-mobile">
              <Image
                loading="lazy"
                src={forgot}
                className="my-5 py-5 imgwidth-100"
              ></Image>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mb-2 mt-5">
                <Image loading="lazy" src={Logo} className="logo_Image"></Image>
                <div
                  style={
                    apiErrDisplay === "Your password has successfully changed"
                      ? { color: "green" }
                      : { color: "red" }
                  }
                  className="p-4"
                >
                  {apiErrDisplay}
                </div>
                <p className="sign-second mt-1 pt-1 pb-2">
                  Create new password
                </p>
              </div>
              <Row>
                <div className="signemail pt-0 pb-3 ">
                  <Form onSubmit={SaveHandler} className="formmain signin-row">
                    <Form.Group
                      className="mb-3"
                      style={{ position: "relative" }}
                      controlId="formBasicPassword"
                    >
                      <Form.Label className="form-label-custom">
                        New Password <span className="star-required">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          onChange={onNewPswd}
                          type={
                            visiblePassword.NewPswd === false ? "password" : ""
                          }
                          placeholder="New Password"
                          className="custom-formcontrol"
                          autoComplete="off"
                        />
                        {visiblePassword.NewPswd === false ? (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2"
                            onClick={() => VisibleHandler("NewPswd")}
                          >
                            <FaEyeSlash className="eyeIcon" />
                          </Button>
                        ) : (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2"
                            onClick={() => NotVisibleHandler("NewPswd")}
                          >
                            <FaEye className="eyeIcon" />
                          </Button>
                        )}
                      </div>
                      <ErrorLabel ErrorDisplay={errDisplayNewPswd} />
                    </Form.Group>
                    <Form.Group
                      className="mb-3"
                      style={{ position: "relative" }}
                      controlId="formBasicPassword"
                    >
                      <Form.Label className="form-label-custom">
                        Confirm Password{" "}
                        <span className="star-required">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          onChange={onConfirmPswd}
                          type={
                            visiblePassword.ConfirmPswd === false
                              ? "password"
                              : ""
                          }
                          placeholder="Confirm Password"
                          className="custom-formcontrol"
                          autoComplete="off"
                        />
                        {visiblePassword.ConfirmPswd === false ? (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2"
                            onClick={() => VisibleHandler("ConfirmPswd")}
                          >
                            <FaEyeSlash className="eyeIcon" />
                          </Button>
                        ) : (
                          <Button
                            variant="outline-secondary"
                            className="edit-mainn px-2"
                            onClick={() => NotVisibleHandler("ConfirmPswd")}
                          >
                            <FaEye className="eyeIcon" />
                          </Button>
                        )}
                      </div>
                      <ErrorLabel ErrorDisplay={errDisplayConfirmPswd} />
                    </Form.Group>
                    <div className="password_Label_Div">
                      <span className="password_Label">
                        (Create a strong password with a mix of upper case
                        letters, alphanumeric and symbols containing at least 8
                        characters.)
                      </span>
                    </div>
                    <div className="text-center">
                      <Button
                        variant="primary"
                        type="submit"
                        className="green-btn mt-3"
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </div>
                <a onClick={BackHandler} style={{ cursor: "pointer" }}>
                  <p className="text-center back-btn">
                    <MdArrowBack />
                    Back
                  </p>
                </a>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CreatePasswordPage;
